export default __webpack_public_path__ + "static/media/Search.5b81b85d.svg";